export default function parameterizeString(string = "") {
  // Trim leading & trailing whitespace, downcase, remove non-alphanumeric characters,
  // and replace spaces with dashes (-). Result: "Owens Corning" -> "owens-corning"
  return string.trim().toLowerCase().replace(/[^a-zA-Z0-9 -]/, "").replace(/\s/g, "-");
}
